/** The whoami page (container): the session's identity and the backend's `GET /me`. */
import { WhoamiCard } from '../components/WhoamiCard.js';
import { useMe, useServices, useSession } from '../app/hooks.js';

export function WhoamiView() {
  const { backend } = useServices();
  const session = useSession();
  const me = useMe();
  if (session === null) return null;
  return (
    <WhoamiCard
      identity={session}
      backend={{ kind: backend.kind, label: backend.label, apiUrl: backend.apiUrl }}
      me={me.data ?? null}
      meError={me.error === null ? null : me.error instanceof Error ? me.error.message : String(me.error)}
    />
  );
}
